import React from "react";

const SiteStructureHeader: React.FC = (props: any) => {
  const NavLabels = [
    "Basic Information",
    "Structure Configuration",
    // "Additional Details",
    // "Review & Submit",
  ];

  return (
    <>
      <div className="steps clearfix">
        <ul>
          {NavLabels.map((item, index, array) => {
            if (index === array.length - 1) {
              return (
                <li
                  key={index}
                  className={props.current === index + 1 ? "last done" : "last"}
                >
                  <a
                    href="#wizard-step"
                    onClick={(ev) => ev.preventDefault()}
                  >
                    <span className="current-info audible">current step: </span>
                    <span className="number">Step {index + 1}</span>
                    <h5>{item}</h5>
                  </a>
                </li>
              );
            }
            return (
              <li
                key={index}
                className={
                  props.current >= index + 1
                    ? `${index === 0 ? "first done" : "done"}`
                    : `${index === 0 ? "first" : ""}`
                }
              >
                <a
                  href={`#wizard-step-${index}`}
                  onClick={(ev) => ev.preventDefault()}
                >
                  <span className="current-info audible">current step: </span>
                  <span className="number">Step {index + 1}</span>{" "}
                  <h5>{item}</h5>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default SiteStructureHeader;
